import { L10nHTML, useL10n } from '@uplift/hooks';
import { YesNoRadioButtonGroup } from '../../../Inputs';
import { LabelInfoTooltip } from '../../../Tooltip';
import { useUserProfileQuery, useUserQuery } from '@uplift/queries';
import { useMemo } from 'react';
import { useCurrentuser } from '@uplift/contexts';

export type IsPrimarySubscriberFormProps = {
  patientId: string;
};

export const IsPrimarySubscriberForm: React.VFC<IsPrimarySubscriberFormProps> = ({ patientId }) => {
  const l10n = useL10n();
  const { data: patient } = useUserQuery(patientId);
  const { data: profile } = useUserProfileQuery(patientId);
  const me = useCurrentuser();

  const label = useMemo(() => {
    if (me?.role === 'superadmin') {
      return l10n.accountSettings.insurance.adminUserIsPrimarySubscriber((profile?.preferredName || patient?.firstName) ?? '');
    }
    return l10n.accountSettings.insurance.userIsPrimarySubscriber;
  }, [ me, patient, profile ]);

  return (
    <div>
      <YesNoRadioButtonGroup
        name="isPrimarySubscriber"
        label={(
          <LabelInfoTooltip
            label={label}
            tooltipTitle={<L10nHTML>{l10n.accountSettings.insurance.isPrimarySubscriberTooltip}</L10nHTML>}
          />
        )}
      />
    </div>
  );
};
